import {MessageSquare, Trash2} from 'lucide-react';

const SettingsActions = (onClearHistory) => (
    <div>
        <div className="flex items-center gap-2 mb-3">
            <MessageSquare className="w-4 h-4 text-zinc-400"/>
            <h3 className="text-xs sm:text-sm font-semibold text-zinc-300 uppercase tracking-wider">
                Actions
            </h3>
        </div>
        <div className="space-y-2">
            <button
                onClick={onClearHistory}
                className="w-full px-4 py-3 bg-red-500/10 hover:bg-red-500/20 border border-red-500/20 rounded-lg transition-all flex items-center justify-center gap-2 text-xs sm:text-sm text-red-300"
            >
                <Trash2 className="w-4 h-4"/>
                <span>Clear Transcription History</span>
            </button>
        </div>
    </div>
)

export default SettingsActions